<template>
  <Layout>
    <router-view></router-view>
  </Layout>
</template>

<script>
import Layout from '@layouts/main'

export default {
  name: 'ViewChargebacks',
  components: { Layout }
}
</script>
